import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useLang } from '../i18n/LanguageContext';
import { SITE_ORIGIN } from './Seo';
import styles from './Legal.module.css';

// ───────────────────────────────────────────────────────────────
// Legal contact details. Placeholders MUST be filled in before going
// live (the Verantwortlicher block needs a real postal address, and
// per BGH since 2023 an email address).
// ───────────────────────────────────────────────────────────────
const NAME = 'Amit Edelman';
const ADDRESS_LINE_1 = 'Glockenblumenweg 136';
const ADDRESS_LINE_2 = '12357 Berlin';
const PHONE = '+49 1523 2782970';
const EMAIL = 'amitsurfer80@gmail.com';

function GermanBody() {
  return (
    <div className={styles.body}>
      <h2 className={styles.h2}>1. Verantwortlicher</h2>
      <p>
        Verantwortlich für die Datenverarbeitung auf dieser Website ist:
        <br />
        {NAME}
        <br />
        {ADDRESS_LINE_1}
        <br />
        {ADDRESS_LINE_2}
        <br />
        Telefon: {PHONE}
        <br />
        E-Mail: {EMAIL}
      </p>

      <h2 className={styles.h2}>2. Hosting</h2>
      <p>
        Diese Website wird bei Cloudflare Pages gehostet. Anbieter ist die
        Cloudflare Germany GmbH (Eppelheimer Straße 49b, 69115 Heidelberg,
        Deutschland) bzw. die Cloudflare, Inc. (101 Townsend Street, San
        Francisco, CA 94107, USA). Cloudflare ist unter dem
        EU-US Data Privacy Framework zertifiziert. Beim Aufruf der Website
        verarbeitet Cloudflare technische Daten (siehe Server-Log-Files),
        die für die Auslieferung der Seite technisch erforderlich sind.
      </p>

      <h2 className={styles.h2}>3. Server-Log-Files</h2>
      <p>
        Der Hosting-Provider erhebt und speichert automatisch Informationen
        in sogenannten Server-Log-Files, die Ihr Browser automatisch
        übermittelt. Dies sind:
      </p>
      <ul>
        <li>Browsertyp und verwendete Version</li>
        <li>das verwendete Betriebssystem</li>
        <li>Referrer-URL</li>
        <li>Hostname des zugreifenden Rechners</li>
        <li>Uhrzeit der Serveranfrage</li>
        <li>die gekürzte IP-Adresse</li>
      </ul>
      <p>
        Diese Daten sind nicht bestimmten Personen zuordenbar. Eine
        Zusammenführung dieser Daten mit anderen Datenquellen wird nicht
        vorgenommen. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs.
        1 lit. f DSGVO zum Zweck der technisch sicheren Bereitstellung der
        Website.
      </p>

      <h2 className={styles.h2}>4. Kontaktformular</h2>
      <p>
        Wenn Sie mich über das Kontaktformular kontaktieren, werden Ihre
        Angaben aus dem Formular zur Bearbeitung der Anfrage und für den
        Fall von Anschlussfragen bei mir gespeichert. Die Übermittlung
        erfolgt über den Dienst Formspree (Betreiber: Formspree). Ich gebe
        diese Daten nicht ohne Ihre Einwilligung weiter. Rechtsgrundlage für
        die Verarbeitung ist Art. 6 Abs. 1 lit. b und f DSGVO. Die Daten
        werden gelöscht, sobald sie für die Erreichung des Zwecks nicht mehr
        erforderlich sind.
      </p>

      <h2 className={styles.h2}>5. Web-Analyse (Cloudflare Web Analytics)</h2>
      <p>
        Diese Website nutzt Cloudflare Web Analytics, einen
        datenschutzfreundlichen, cookiefreien Analysedienst der
        Cloudflare, Inc. Es werden keine Cookies gesetzt und Ihr Browser
        wird nicht durch ein Consent-Banner unterbrochen. Es werden
        ausschließlich aggregierte, anonyme Metadaten erfasst (Seitenaufrufe,
        Herkunftsland, Gerätetyp, automatische Bot-Erkennung). Eine
        Zuordnung zu einer bestimmten Person ist nicht möglich. Die
        IP-Adresse wird von Cloudflare gekürzt und nicht gespeichert.
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO; das berechtigte
        Interesse liegt in der statistischen Auswertung der Nutzung zur
        Verbesserung des Angebots.
      </p>

      <h2 className={styles.h2}>
        6. Eingebettete Videos (Cloudflare Stream, YouTube)
      </h2>
      <p>
        Auf den Fallstudie-Seiten können Videos eingebettet sein.
        Cloudflare-Stream-Videos werden über die Cloudflare-Infrastruktur
        ausgeliefert. YouTube-Videos werden im Privacy enhanced Mode über
        die Domain youtube-nocookie.com eingebettet, sodass YouTube keine
        Cookies setzt, bevor Sie das Video starten. Beim Abspielen eines
        Videos kann der jeweilige Anbieter Verbindungsinformationen
        verarbeiten. Wenn Sie nicht möchten, dass YouTube oder Cloudflare
        Daten über Ihr Nutzungsverhalten erheben, starten Sie das Video
        nicht.
      </p>

      <h2 className={styles.h2}>7. Schriften</h2>
      <p>
        Diese Website verwendet ausschließlich selbst gehostete Schriften.
        Es findet keine Verbindung zu Google-Servern oder anderen
        Drittanbieter-Schriftservices statt; es werden keine Schriftarten
        von externen Servern geladen.
      </p>

      <h2 className={styles.h2}>8. SSL/TLS-Verschlüsselung</h2>
      <p>
        Diese Seite nutzt aus Gründen der Sicherheit und zum Schutz der
        Übertragung vertraulicher Inhalte eine SSL/TLS-Verschlüsselung. Eine
        verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile
        des Browsers von „http://&quot; auf „https://&quot; wechselt und am
        Schloss-Symbol in Ihrer Browserzeile.
      </p>

      <h2 className={styles.h2}>9. Widerspruch gegen Werbe-E-Mails</h2>
      <p>
        Der Nutzung der im Rahmen der Impressumspflicht veröffentlichten
        Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter
        Werbung und Informationsmaterial wird hiermit widersprochen. Ich
        behalte mir rechtliche Schritte im Falle der unverlangten Zusendung
        von Werbeinformationen, etwa durch Spam-E-Mails, ausdrücklich vor.
      </p>

      <h2 className={styles.h2}>10. Ihre Rechte</h2>
      <p>
        Sie haben jederzeit das Recht auf unentgeltliche Auskunft über die
        zu Ihrer Person gespeicherten personenbezogenen Daten, deren
        Herkunft und Empfänger sowie den Zweck der Datenverarbeitung. Darüber
        hinaus stehen Ihnen folgende Rechte zu:
      </p>
      <ul>
        <li>Recht auf Berichtigung unrichtiger Daten</li>
        <li>Recht auf Löschung („Recht auf Vergessenwerden&quot;)</li>
        <li>Recht auf Einschränkung der Verarbeitung</li>
        <li>Recht auf Datenübertragbarkeit</li>
        <li>Recht auf Widerspruch gegen die Verarbeitung</li>
        <li>
          Recht auf Widerruf einer erteilten Einwilligung (dazu reicht eine
          formlose E-Mail)
        </li>
      </ul>

      <h2 className={styles.h2}>
        11. Beschwerderecht bei der Aufsichtsbehörde
      </h2>
      <p>
        Ihnen steht ein Beschwerderecht bei einer Datenschutz-Aufsichtsbehörde
        zu. Die für Berlin zuständige Behörde ist die Berliner Beauftragte
        für Datenschutz und Informationsfreiheit (
        <a
          href="https://www.datenschutz-berlin.de"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.datenschutz-berlin.de
        </a>
        ).
      </p>
    </div>
  );
}

function EnglishBody() {
  return (
    <div className={styles.body}>
      <h2 className={styles.h2}>1. Controller</h2>
      <p>
        The controller responsible for data processing on this website is:
        <br />
        {NAME}
        <br />
        {ADDRESS_LINE_1}
        <br />
        {ADDRESS_LINE_2}
        <br />
        Phone: {PHONE}
        <br />
        Email: {EMAIL}
      </p>

      <h2 className={styles.h2}>2. Hosting</h2>
      <p>
        This website is hosted on Cloudflare Pages. The provider is Cloudflare
        Germany GmbH (Eppelheimer Straße 49b, 69115 Heidelberg, Germany) and/or
        Cloudflare, Inc. (101 Townsend Street, San Francisco, CA 94107, USA).
        Cloudflare is certified under the EU-US Data Privacy Framework. When the
        site is called up, Cloudflare processes technical data (see Server Log
        Files) that are technically necessary to deliver the page.
      </p>

      <h2 className={styles.h2}>3. Server log files</h2>
      <p>
        The hosting provider automatically collects and stores information in
        so-called server log files, which your browser transmits
        automatically. These are:
      </p>
      <ul>
        <li>Browser type and version used</li>
        <li>the operating system used</li>
        <li>referrer URL</li>
        <li>hostname of the accessing computer</li>
        <li>time of the server request</li>
        <li>the truncated IP address</li>
      </ul>
      <p>
        This data cannot be assigned to specific persons. This data is not
        merged with other data sources. Processing is based on Art. 6 para. 1
        lit. f GDPR for the purpose of technically secure provision of the
        website.
      </p>

      <h2 className={styles.h2}>4. Contact form</h2>
      <p>
        If you contact me via the contact form, your details from the form will
        be stored with me to process the request and in case of follow-up
        questions. Transmission takes place via the Formspree service (operator:
        Formspree). I do not pass on this data without your consent. The legal
        basis for processing is Art. 6 para. 1 lit. b and f GDPR. The data will
        be deleted as soon as it is no longer necessary to achieve the purpose.
      </p>

      <h2 className={styles.h2}>5. Web analytics (Cloudflare Web Analytics)</h2>
      <p>
        This website uses Cloudflare Web Analytics, a privacy-friendly,
        cookie-free analytics service from Cloudflare, Inc. No cookies are set
        and your browser is not interrupted by a consent banner. Only
        aggregated, anonymous metadata is recorded (page views, country of
        origin, device type, automatic bot detection). It is not possible to
        assign this to a specific person. The IP address is truncated by
        Cloudflare and not stored. The legal basis is Art. 6 para. 1 lit. f
        GDPR; the legitimate interest lies in the statistical evaluation of
        usage to improve the offering.
      </p>

      <h2 className={styles.h2}>6. Embedded videos (Cloudflare Stream, YouTube)</h2>
      <p>
        Videos may be embedded on the case study pages. Cloudflare Stream
        videos are delivered via the Cloudflare infrastructure. YouTube videos
        are embedded in Privacy Enhanced Mode via the youtube-nocookie.com
        domain, so YouTube does not set cookies before you start the video.
        When a video is played, the respective provider may process connection
        information. If you do not want YouTube or Cloudflare to collect data
        about your usage behavior, do not start the video.
      </p>

      <h2 className={styles.h2}>7. Fonts</h2>
      <p>
        This website uses exclusively self-hosted fonts. There is no connection
        to Google servers or other third-party font services; no fonts are
        loaded from external servers.
      </p>

      <h2 className={styles.h2}>8. SSL/TLS encryption</h2>
      <p>
        For security reasons and to protect the transmission of confidential
        content, this site uses SSL/TLS encryption. You can recognize an
        encrypted connection by the fact that the browser address bar changes
        from „http://&quot; to „https://&quot; and by the lock symbol in your
        browser bar.
      </p>

      <h2 className={styles.h2}>9. Objection to advertising emails</h2>
      <p>
        The use of the contact data published within the scope of the
        Impressum obligation for the sending of advertising and information
        material not expressly requested is hereby objected to. I expressly
        reserve the right to take legal action in the event of the unsolicited
        sending of advertising information, such as spam emails.
      </p>

      <h2 className={styles.h2}>10. Your rights</h2>
      <p>
        You have the right at any time to receive free information about the
        personal data stored about you, its origin and recipients, and the
        purpose of data processing. You also have the following rights:
      </p>
      <ul>
        <li>Right to rectification of incorrect data</li>
        <li>Right to erasure („right to be forgotten&quot;)</li>
        <li>Right to restriction of processing</li>
        <li>Right to data portability</li>
        <li>Right to object to processing</li>
        <li>
          Right to withdraw consent given (an informal email is sufficient)
        </li>
      </ul>

      <h2 className={styles.h2}>11. Right to complain to the supervisory authority</h2>
      <p>
        You have the right to lodge a complaint with a data protection
        supervisory authority. The authority responsible for Berlin is the
        Berlin Commissioner for Data Protection and Freedom of Information (
        <a
          href="https://www.datenschutz-berlin.de"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.datenschutz-berlin.de
        </a>
        ).
      </p>
    </div>
  );
}

export default function Datenschutz() {
  const { lang, buildPath, tr } = useLang();
  const isDe = lang === 'de';

  const title = isDe ? 'Datenschutz | EDELNAD Productions' : 'Privacy policy (Datenschutz) | EDELNAD Productions';
  const description = isDe
    ? 'Datenschutzerklärung von EDELNAD Productions (Amit Edelman, Berlin): Hosting, Kontaktformular, Web-Analyse, eingebettete Videos und Ihre Datenschutzrechte.'
    : 'Privacy policy of EDELNAD Productions (Amit Edelman, Berlin): hosting, contact form, web analytics, embedded videos and your data protection rights.';
  const langPath = '/datenschutz';
  const canonical = `${SITE_ORIGIN}${isDe ? '/de' : ''}${langPath}`;

  return (
    <section className={styles.section}>
      <Helmet>
        <html lang={lang} />
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonical} />
        <link rel="alternate" hrefLang="en" href={`${SITE_ORIGIN}${langPath}`} />
        <link rel="alternate" hrefLang="de" href={`${SITE_ORIGIN}/de${langPath}`} />
        <link rel="alternate" hrefLang="x-default" href={`${SITE_ORIGIN}${langPath}`} />
        <meta name="robots" content="index, follow" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="EDELNAD Productions" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={canonical} />
        <meta property="og:locale" content={isDe ? 'de_DE' : 'en_US'} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
      </Helmet>

      <div className={`container ${styles.inner}`}>
        <Link to={buildPath('/')} className={styles.back}>
          {tr('← Back to home', '← Zurück zur Startseite')}
        </Link>

        <p className="section-label">{tr('Legal', 'Datenschutz')}</p>
        <h1 className={styles.title}>
          {isDe ? 'Datenschutzerklärung' : 'Privacy Policy (Datenschutzerklärung)'}
        </h1>

        <p className={styles.intro}>
          {isDe ? (
            <>
              Der Schutz Ihrer persönlichen Daten ist mir ein wichtiges Anliegen.
              Ich verarbeite Ihre personenbezogenen Daten ausschließlich auf
              Grundlage der gesetzlichen Bestimmungen (DSGVO, BDSG, TKG/DDG). Diese
              Datenschutzerklärung informiert Sie über die Verarbeitung
              personenbezogener Daten bei der Nutzung dieser Website.
            </>
          ) : (
            <>
              The protection of your personal data is important to me. I process
              your personal data exclusively on the basis of the statutory
              provisions (GDPR, BDSG, TKG/DDG). This privacy policy informs you
              about the processing of personal data when using this website.
            </>
          )}
        </p>

        {isDe ? <GermanBody /> : <EnglishBody />}

        <nav className={styles.footNav} aria-label="Legal navigation">
          <Link to={buildPath('/')} className={styles.footLink}>
            {tr('← Home', '← Start')}
          </Link>
          <Link to={buildPath('/impressum')} className={styles.footLink}>
            {tr('Impressum →', 'Impressum →')}
          </Link>
        </nav>
      </div>
    </section>
  );
}
